<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading || archiveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                {{ mode }} Category
            </h2>
            <div class="pb-0">
                <v-form name="categoryEditForm" ref="categoryEditForm">

                    <div class="tw-flex tw-mb-2 tw-p-2">
                        <div class="tw-flex tw-flex-col tw-w-full tw-gap-4">
                            <v-text-field
                                v-model="modelObject.priority"
                                label="Priority"
                                type="number"
                                hide-details
                                clearable
                            ></v-text-field>
                            <v-text-field
                                v-model="modelObject.abbreviation"
                                label="Abbreviation"
                                :rules="[rules.required]"
                                hide-details
                                clearable
                            ></v-text-field>
                            <v-text-field
                                v-model="modelObject.name"
                                label="Category Name"
                                :rules="[rules.required]"
                                hide-details
                                clearable
                            ></v-text-field>
                            <v-select
                                v-model="modelObject.department"
                                :items="getDepartments"
                                dense
                                color="primary"
                                label="Department"
                                display-label="Department"
                                :rules="[rules.required]"
                                hide-details
                                reactive
                                outlined
                            />
                            <v-textarea
                                v-model="modelObject.description"
                                label="Description"
                                auto-grow
                                hide-details
                                outlined
                                dense
                                clearable
                                rows="1"
                            ></v-textarea>
                            <v-checkbox
                                v-model="modelObject.display_website"
                                label="Website"
                                hide-details
                                dense
                            ></v-checkbox>
                            <v-checkbox
                                v-model="modelObject.include_in_report"
                                label="Include In Report"
                                hide-details
                                dense
                            ></v-checkbox>
                            <v-checkbox
                                v-model="modelObject.abbreviate_in_report"
                                label="Use Abbreviation In Report"
                                hide-details
                                dense
                            ></v-checkbox>
                            <v-checkbox
                                v-model="modelObject.production_crew_default"
                                label="Production Crew"
                                hide-details
                                dense
                            ></v-checkbox>

                            <v-select
                                v-model="modelObject.default_camera"
                                :items="['A','B','C','D']"
                                dense
                                color="primary"
                                label="Camera"
                                display-label="Camera"
                                hide-details
                                reactive
                                outlined
                            />
                        </div>
                    </div>
                </v-form>
            </div>

            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3" >
                <v-btn
                    text
                    @click="archiveModel"
                    class="btn-solid"
                    :loading="archiveLoading"
                    v-show="is_edit_mode && isUserAdmin()"
                >
                    Delete
                </v-btn>
                <v-btn
                    text
                    @click="cancelDialog"
                    class="main-btn"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="saveModel"
                    class="main-btn"
                    :loading="saveLoading"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name: "EditCategoryModal",
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: true
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'constants': {
            // The constants we will rely on
            type: Object,
            required: true
        },
        'valuelists': {
            // The constants we will rely on
            type: Object,
            required: false
        },
    },
    updated() {
        //
    },
    data() {
        return {
            dialog: this.value || false,
            mode: '',
            modelObject: {},
            modelDefault: {
                id: null,
                name: null,
                abbreviation: null,
                department: null,
                priority: undefined,
                description: null,
                display_website: false,
                include_in_report: false,
                production_crew_default: false,
                default_camera: null,
            },
            saveLoading: false,
            archiveLoading: false,
            rules: {
                required: value => !!value || 'Required',
            },
        }
    },
    mounted() {
        //
    },
    computed: {
        dialog_width() {
            return '550px'
        },
        is_edit_mode() {
            return this.mode === 'Edit' ? true : false
        },
        getDepartments() {
            return Object.values(this.constants.TITLE_FUNCTION_DEPARTMENTS)
        },
    },
    methods: {
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        saveModel() {
            //let payload = this.modelObject

            if (this.$refs.categoryEditForm.validate()) {

                let formData = this.modelObject

                var url = ''
                var method = ''

                if( this.is_edit_mode ) {
                    url = route('categories.update', this.modelObject.id)
                    formData["_method"] = "put"
                } else {
                    url = route('categories.store')
                    method = 'post'
                }

                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                    onUploadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Changes have been saved')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.saveLoading = false
                            this.$emit('successful-category-save')
                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknow error.')
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                        } else {
                            console.log(error)
                            this.$root.snackbar.error(error)
                        }
                        this.saveLoading = false
                    })
            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },
        async archiveModel()
        {
            if (await this.$root.confirm.open(`Delete Category`, `You are about to delete ${this.modelObject.name}`)) {

                let method = 'delete'
                let url = route('categories.destroy', this.modelObject.id)
                let payload = this.modelObject

                axios({
                    method: method,
                    url: url,
                    data: payload,
                    onUploadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Category has been deleted')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archiveLoading = false
                            this.$emit('successful-category-delete')
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                        this.archiveLoading = false
                    })
            }
        },
        isUserAdmin() {
            if (this.$page.user.role === 'ADMIN') {
                return true
            } else {
                return false
            }
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
                this.$refs.categoryEditForm.resetValidation()
            } else {
                // Opening modal
                if (this.modelProp === null) {
                    this.mode = 'Add'
                    this.modelObject = structuredClone(this.modelDefault)
                } else {
                    this.mode = 'Edit'
                    this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)))
                }
            }
        },
    },
}

</script>

<style scoped>

</style>
